<template>
  <div class="login-container">
    <div class="login-card">
      <div>
        <h5 class="text-center text-white mt-3">ระบบบริหารจัดการน้ำสูญเสีย การประปาส่วนภูมิภาค</h5>
      </div>
      <div>
        <v-img src="../assets/logo_large.png" alt="logo" class="login-img"/>
      </div>
      <div>
        <form @submit.prevent="onSubmit">
          <div>
            <label class="label" for="username">Username</label>
            <input
              id="username"
              v-model="form.username"
              required
              class="login-input"
              placeholder="Username"
            >
          </div>

          <div>
            <label class="label" for="password">Password</label>
            <input
              id="password"
              type="password"
              v-model="form.password"
              required
              class="login-input"
              placeholder="Password"
            />
          </div>

          <v-btn class="login-btn" type="submit" :loading="loading">LOGIN</v-btn>
          <a class="forgot-password" href="/password/reset">Forgot your password?</a>
        </form>

        <v-snackbar
          v-model="snackbar"
          :bottom="true"
          :right="true"
          :vertical="true"
          color="error"
          :timeout="6000"
        >
          <h5>เข้าสู่ระบบไม่สำเร็จ</h5>
          <br>
          {{ text }}
          <v-btn
            dark
            text
            @click="snackbar = false"
          >
            ปิด
          </v-btn>
        </v-snackbar>

      </div>
    </div>
  </div>
</template>

<script>
  import Api from '../providers/Api'

  export default {
    data () {
      return {
        form: {
          username: '',
          password: '',
        },
        loading: false,
        snackbar: false,
        text: '',
      }
    },

    created () {
      if (this.checkLogin()) {
        this.$router.push('/home')
      }
    },

    methods: {
      onSubmit () {
        this.loading = true

        this.post('/api/login', this.form, false)
          .then(({ data }) => {
            this.setToken(data)

            this.$store.state.need_register_line = data.need_register_line

            this.$router.push(this.$store.state.intended || '/home')
            this.$store.state.intended = null;
          })
          .catch(error => {
            this.text = error.response.data.errors.username[0]
            this.snackbar = true
          })
          .finally(() => this.loading = false)
      },
    },

    mixins: [
      Api,
    ],
  }
</script>

<style lang="scss" scoped>
  .login-container {
    width: 100vw;
    height: 100vh;
    background-color: #017CB7;
    display: flex;
    justify-content: center;
    color: white;

    .login-card {
      width: 256px;

      .login-img {
        width: 150px;
        height: auto;
        margin: 40px auto 30px;
        display: block;
      }

      .label {
        margin-bottom: 10px;
      }

      .login-input {
        background-color: #F2F2F2 !important;
        color: black !important;
        border-radius: 20px !important;
        border: none !important;
        width: 100%;
        padding: 10px 20px;
        margin: 10px 0 20px;

        &::placeholder {
          font-style: normal !important;
          font-weight: normal !important;
          font-size: 16px !important;
          line-height: 21px !important;
          color: #BDBDBD !important;
        }
      }

      .login-btn {
        border-radius: 24px;
        margin: 30px 0 10px;
        width: 100%;
        background-color: #0054A4 !important;
        font-weight: bold;
        color: white;

        &:hover {
          background-color: rgba(0, 84, 164, 0.7) !important;
        }
      }

      .forgot-password {
        text-align: center;
        color: #6BD1ED;
        display: block;
      }
    }
  }
</style>
